'use client';

import { BreadcrumbItem, breadcrumbItemTag } from '@ni/nimble-components/dist/esm/breadcrumb-item';
import { wrap } from '../utilities/react-wrapper';

export { breadcrumbItemTag };
export { type BreadcrumbItem };
export const NimbleBreadcrumbItem = wrap(BreadcrumbItem);
